// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2giHz","inner":"Form_inner__2m6Hx","range":"Form_range__dVi0k","name":"Form_name__3pNPs","actions":"Form_actions__3nIYn"};